import { bindable } from "aurelia-templating";
import { autoinject } from "aurelia-dependency-injection";

//Load styles
require("./comp-text-area.scss");
@autoinject
export class CompTextArea {

    public constructor(private element: Element) {
    }

    @bindable
    public rows: number = 1;

    @bindable
    public maxRows: number;

    @bindable
    public label: string;

    @bindable
    public value: string;

    @bindable
    public info: string = "";

    @bindable
    public infoBottom: string = "";

    @bindable
    public placeholder: string = "";

    @bindable
    public resizeable: boolean;

    @bindable
    public readonly: boolean;

    @bindable
    public disabled: boolean;

    @bindable
    public tab: number;
    
    @bindable
    public maxLength: number = 99999;
    
    @bindable
    public height: number;

    valueChanged(newValue: string, oldValue: string) {
        const changeTextEvent: CustomEvent = new CustomEvent("text-changed", { bubbles: true, detail: {
            value: newValue, oldValue
        } });
        this.element.dispatchEvent(changeTextEvent);
    }
}
